module.exports = Object.freeze({
  COMPANY: "",
  COMAPNT_EN: "",
});
